module.exports = __webpack_public_path__ + "img/newspaper-variant-outline.44980e9e.svg";